/**
 * Client view of GET /profiles/me/ plan + entitlements.
 * Missing or junk payload fails closed (free, no clubs/toolkit/parcels).
 */

export function parseEntitlements(payload) {
  const data = payload && typeof payload === 'object' && !Array.isArray(payload) ? payload : {};
  const raw = data.entitlements && typeof data.entitlements === 'object' && !Array.isArray(data.entitlements)
    ? data.entitlements
    : {};
  return {
    plan: data.plan === 'pro' ? 'pro' : 'free',
    entitlements: {
      clubs: raw.clubs === true,
      toolkit: raw.toolkit === true,
      parcels: raw.parcels === true,
    },
  };
}

export function hasEntitlement(parsed, key) {
  return Boolean(parsed?.entitlements?.[key]);
}

/**
 * Turning feed tracking on requires Toolkit. Clearing it, and leaving
 * an already-on station as-is, stay allowed.
 */
export function shouldGateFeedEnable(canEnableFeed, nextFeedOn) {
  return Boolean(nextFeedOn) && canEnableFeed !== true;
}

/** Logging fills and other feed writes require Toolkit. */
export function shouldGateFeedWrite(canEnableFeed) {
  return canEnableFeed !== true;
}

/** Turning Parcels (boundaries + owner sheet) on requires Pro. */
export function shouldGateParcelsEnable(canEnableParcels, nextOn) {
  return Boolean(nextOn) && canEnableParcels !== true;
}

/** 403 `{ code: 'pro_required', entitlement }` from the Clubs/Toolkit API gates. */
export function isProRequiredError(err, entitlement) {
  const data = err?.response?.data;
  if (!data || typeof data !== 'object' || data.code !== 'pro_required') return false;
  if (entitlement && data.entitlement !== entitlement) return false;
  return true;
}
